import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ChartSeries} from "./chart-series";
import {Subject} from "rxjs";

@Component({
    selector: "bi-chart",
    templateUrl: "./chart.component.html",
    styleUrls: ["./chart.component.scss"]
})
export class ChartComponent {

    @Input() title: string;

    @Input() xAxisLabel: string;

    @Input() chartType: string;

    @Input() selectedRefLine: string;

    @Input() seriesData: Subject<ChartSeries[]>;

    /**
     * Map of full qualified hierarchy names that map to logical child hierarchies.
     */
    @Input() childHierarchies: { [key: string]: string; };

    @Input() showActions: boolean = false;

    @Input() height: number = 400;

    @Input() enableDrillDown: boolean = false;
    @Input() enableDrillUp: boolean = false;

    @Output() onDrop: EventEmitter<any> = new EventEmitter<any>();

    @Output() removed: EventEmitter<any> = new EventEmitter<any>();
    @Output() added: EventEmitter<any> = new EventEmitter<any>();
    @Output() memberSelection: EventEmitter<any> = new EventEmitter();
    @Output() drillDown: EventEmitter<any> = new EventEmitter();
    @Output() drillUp: EventEmitter<any> = new EventEmitter();

    public itemDropped(o: any): void {
        this.onDrop.emit(o);
    }

    public remove(): void {
        this.removed.emit();
    }

    public add(): void {
        this.added.emit();
    }

    public memberSelected(e: any) {
        this.memberSelection.emit(e);
    }
}
